import {
	ListItemNodeSpec,
	OrderedListNodeSpec,
	UnorderedListNodeSpec,
	ORDERED_LIST_KEY,
	UNORDERED_LIST_KEY,
	LIST_ITEM_KEY,
} from '@techchange/pm-specs';

import OrderedListButton from './components/OrderedListButton';
import UnorderedListButton from './components/UnorderedListButton';
import listKeymap from './plugins/keymap';

const list = {

	nodes() {

		return {
			[LIST_ITEM_KEY]: ListItemNodeSpec,
			[ORDERED_LIST_KEY]: OrderedListNodeSpec,
			[UNORDERED_LIST_KEY]: UnorderedListNodeSpec,
		};

	},

	plugins() {

		return [listKeymap];

	},

	toolbarButtons() {

		return [
			{ Button: OrderedListButton, key: 'OrderedListButton' },
			{ Button: UnorderedListButton, key: 'UnorderedListButton' }
		];

	},

};

export default list;
